import type { StatusCatalog } from '../../services/statusCatalog';

export interface StatusPreview {
    phase: string; // macro display label, e.g. "Hold"
    name: string; // step name with macro prefix stripped, e.g. "1. Records incomplete"
}

export function statusPreview(id: string, catalog: StatusCatalog): StatusPreview {
    return { phase: catalog.meta(id)?.phase ?? '', name: catalog.display(id) };
}
